import { ServiceIdSchema, UserIdSchema } from "@core/domains/identity";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

import { FolderStructureSchema } from "./folder-structure.ts";
import { TaxonomyIdSchema, generateTaxonomyId } from "./shared/taxonomy-id.ts";

export const Taxonomy = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), id: generateTaxonomyId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        controllerPrincipalId: ServiceIdSchema,
        folderStructure: FolderStructureSchema,
        id: TaxonomyIdSchema,
        name: z.string(),
        principalId: UserIdSchema,
      },
      {
        controllerPrincipalId:
          "The id of the service that controls the taxonomy for the user.",
        folderStructure: "The taxonomy's current folder structure.",
        id: "The unique identifier for the taxonomy.",
        name: "The taxonomy's name.",
        principalId: "The id of the user the taxonomy belongs to.",
      },
    ),
    defaults: { folderStructure: { folders: [] } },
    derive: {
      create: schema => schema.omit({ id: true }),
      recovery: (schema, { base }) =>
        schema.extend(
          {
            folderStructure: base.shape.folderStructure
              .extend(
                {
                  folders: base.shape.folderStructure.shape.folders.default(
                    () => [],
                  ),
                },
                { folders: base.shape.folderStructure.descriptions.folders },
              )
              .default(() => {
                return { folders: [] };
              }),
          },
          { folderStructure: schema.descriptions.folderStructure },
        ),
      update: schema => schema.pick({ folderStructure: true }).partial(),
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface Taxonomy extends z.infer<typeof Taxonomy.schema> {}
